module.exports = __webpack_public_path__ + "img/nature-33.ae7cfb10.jpg";